import axios from "axios";

const requestObituary = id => {
  //
  // const res = axios.get(`localhost:8081/api/obituary?id=${id}`);

  //

  // return res;
  return axios.get(`${process.env.VUE_APP_APIURL}/api/obituary?id=${id}`);
};

function requestMortuaryList() {
  return axios.get(`${process.env.VUE_APP_APIURL}/api/app/mortuary/list`);
}

// new
const requestObituaryList = parameter => {
  return axios.get(
    `${
      process.env.VUE_APP_APIURL
    }/api/app/obituary/list?endFlag=${encodeURIComponent(
      parameter.endFlag
    )}&searchTxt=${encodeURIComponent(
      parameter.searchTxt
    )}&searchType=${encodeURIComponent(parameter.searchType)}
    `
  );
};
const requestFuneralObituaryList = parameter => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/funeral/list?id=${
      parameter.id
    }&endFlag=${encodeURIComponent(
      parameter.endFlag
    )}&searchTxt=${encodeURIComponent(
      parameter.searchTxt
    )}&searchType=${encodeURIComponent(parameter.searchType)}&page=${
      parameter.page
    }
    `
  );
};
const requestCorpObituaryList = parameter => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/corp/list?id=${
      parameter.id
    }&endFlag=${encodeURIComponent(
      parameter.endFlag
    )}&searchTxt=${encodeURIComponent(
      parameter.searchTxt
    )}&searchType=${encodeURIComponent(parameter.searchType)}&page=${
      parameter.page
    }
    `
  );
};

const requestDirectorObituaryList = parameter => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/director/list?id=${
      parameter.id
    }&endFlag=${encodeURIComponent(
      parameter.endFlag
    )}&searchTxt=${encodeURIComponent(
      parameter.searchTxt
    )}&searchType=${encodeURIComponent(parameter.searchType)}&page=${
      parameter.page
    }
    `
  );
};

function requestObituarySend(id) {
  return axios.post(
    `http://www.jangryebaksa.com/api/app/obituary/sendAll?id=${id}`
  );
  // return axios.get(
  //   `${process.env.VUE_APP_BASEURL}/api/app/obituary/sendAll?id=${id}`
  // );
}

// 부고장 만들어질 때 모든 번호에게 부고장 발송
const requestObituarySendAllOnly = (obituaryId, msgType) => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/sendAllOnly?id=${obituaryId}`,
    { msgType }
  );
};
// 선택 전송하기
const requestObituarySendSelected = ({
  obituaryId,
  selectMemberList,
  msgType,
  showType
}) => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/sendSelected?id=${obituaryId}`,
    {
      selectMemberList,
      msgType,
      showType
    }
  );
};
// 상주 외 부고전송
const requestObituarySendOther = ({
  smsBody,
  memberList
}) => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/sendOther`,
    {
      smsBody,
      memberList,
    }
  );
};
const requestObituaryOnlySend = ({
  id,
  msgType,
  smsBody,
  showType,
  accountShowType
}) => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/send?id=${id}`,
    {
      msgType,
      smsBody,
      showType,
      accountShowType
    }
  );
};

// new
const requestObituaryOnlyReply = id => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/reply?id=${id}`
  );
};

// 추가추가추가추가
const requestObituaryOnlyReplyKakao = id => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/replykakao?id=${id}`
  );
};

// new
const requestObituaryOnlyMovie = id => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/movie?id=${id}`
  );
};

// new
const requestObituaryReg = parameter => {
  let form = new FormData();
  for (let i = 0; i < parameter.files.length; i++) {
    form.append("fileList", parameter.files[i]);
  }
  const obituaryParam = parameter.obituary;
  var obituaryParamString = JSON.stringify(obituaryParam);
  form.append("obituaryParamString", obituaryParamString);

  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/reg`,
    form,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );
};

const requestObituaryRegTmp = parameter => {
  let form = new FormData();
  for (let i = 0; i < parameter.files?.length; i++) {
    form.append("fileList", parameter.files[i]);
  }
  console.log(parameter)
  const obituaryParam = parameter.obituary;
  var obituaryParamString = JSON.stringify(obituaryParam);
  form.append("obituaryParamString", obituaryParamString);

  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/regTmp`,
    form,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );
};

const requestObituaryRegTmpUpdate = parameter => {
  return axios.put(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/regTmpUpdate`,
    parameter
  );
};

const requestObituaryRegTmpLoad = id => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/regTmpLoad?id=${id}`
  );
};

// new
const requestObituaryUpdate = parameter => {
  let form = new FormData();
  for (let i = 0; i < parameter.files.length; i++) {
    form.append("fileList", parameter.files[i]);
  }
  const obituaryParam = parameter.obituary;
  var obituaryParamString = JSON.stringify(obituaryParam);
  form.append("obituaryParamString", obituaryParamString);

  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/update`,
    form,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );
};

//new
const requestObituaryDetail = id => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/detail?id=${id}`
  );
};

function requestObituaryAllList() {
  return axios.get(`${process.env.VUE_APP_BASEURL}/api/app/obituary/allList`);
}

// new
const requestObituaryDelete = parameter => {
  return axios.post(
    `${
      process.env.VUE_APP_APIURL
    }/api/app/obituary/delete?endFlag=${encodeURIComponent(
      parameter.endFlag
    )}&searchTxt=${encodeURIComponent(
      parameter.searchTxt
    )}&searchType=${encodeURIComponent(parameter.searchType)}`,
    parameter.obituary
  );
};

const requestObituaryChangeCorp = parameter => {
  return axios.put(
    `${process.env.VUE_APP_APIURL}/api/app/obituary/corp-change`,
    parameter
  );
};

export {
  requestMortuaryList,
  requestObituaryList,
  requestObituaryDelete,
  requestObituaryReg,
  requestObituaryRegTmp,
  requestObituaryRegTmpUpdate,
  requestObituaryRegTmpLoad,
  requestObituaryUpdate,
  requestObituaryDetail,
  requestObituarySend,
  requestObituarySendAllOnly,
  requestObituarySendSelected,
  requestObituarySendOther,
  requestObituaryOnlySend,
  requestObituaryAllList,
  requestObituaryOnlyReply,
  requestObituaryOnlyReplyKakao,
  requestObituaryOnlyMovie,
  requestObituary,
  //
  requestObituaryChangeCorp,
  requestFuneralObituaryList,
  requestCorpObituaryList,
  requestDirectorObituaryList
};
